import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    value: false,
};

export const loaderSlice = createSlice({
    name: "loader",
    initialState: initialState,
    reducers: {
        openLoader: (state, action) => {
            state.value = true;
        },
        closeLoader: (state, action) => {
            state.value = false;
        },
    },
});

export const { openLoader, closeLoader } = loaderSlice.actions;
export default loaderSlice.reducer;
